import { type SVGProps } from 'react';

interface BasketballIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  strokeWidth?: number;
}

const BasketballIcon = ({ size = 24, strokeWidth = 2, className, ...props }: BasketballIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Outer circle */}
    <circle cx="12" cy="12" r="10" />
    {/* Vertical line */}
    <path d="M12 2v20" />
    {/* Horizontal line */}
    <path d="M2 12h20" />
    {/* Left curve */}
    <path d="M5.2 5.2c2.6 2.6 2.6 11 0 13.6" />
    {/* Right curve */}
    <path d="M18.8 5.2c-2.6 2.6-2.6 11 0 13.6" />
  </svg>
);

export default BasketballIcon;
